// extracted by mini-css-extract-plugin
export default {"error-layout-root":"ErrorLayout_error-layout-root__Tr+X5","main-content":"ErrorLayout_main-content__Vsymp"};